import Navbar from "@/components/site/Navbar";
import Manifesto from "@/components/site/Manifesto";
import Stats from "@/components/site/Stats";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function ProcessPage() {
  return (
    <main className="bg-[#050505]" data-testid="process-page">
      <Navbar />
      <div className="pt-24 md:pt-28">
        <Manifesto />
      </div>
      <Stats />
      <QuoteForm />
      <Footer />
    </main>
  );
}
